import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const BackAction = () => {
    const navigate = useNavigate()
    return (
        <button
            type='button' onClick={() => navigate(-1)}
            className='w-fit inline-flex items-center gap-2 capitalize text-text-blue-200 title2'
        >
            <ArrowLeft />
            <span>Kembali</span>
        </button>
    )
}

export default BackAction
